/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(data) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      SubmitSEG: {
        $xmlns: 'http://dobs.pa.gov/dp/seg/bpm/1.0',
        SEGLocationID: data.segLocationId,
        EntityID: data.entityId,
        SegID: data.segId,
        Name: data.name,
        IsNonProfit: data.isNonProfit,
        EntityTypeID: data.entityTypeId,
        StateOfIncorporation: data.stateOfIncorporation,
        Website: data.website,
        EmployeeCount: data.employeeCount,
        StatusID: data.statusId,
        AddressID: data.addressId,
        Address: {
          AddressLine1: data.addressLine1,
          AddressLine2: data.addressLine2,
          AddressLine3: data.addressLine3,
          City: data.city,
          State: data.state,
          PostalCode: data.postalCode,
          Country: data.country,
          County: data.county
        },
        FirstName: data.firstName,
        MiddleName: data.middleName,
        LastName: data.lastName,
        SSN: data.ssn,
        Comments: data.comments,
        ApprovalDate: data.approvalDate ? moment(data.approvalDate, 'MM-DD-YYYY').format('YYYY-MM-DD') : null,
        TerminationDate: data.terminationDate ? moment(data.terminationDate, 'MM-DD-YYYY').format('YYYY-MM-DD') : null,
        IsDeleted: data.isDeleted,
        IndividualTypes: (function() {
          if (!data.individualTypes || !data.individualTypes.length) {
            return {};
          }
          return {
            TypeID: data.individualTypes
          };
        })()
      }
    },
    blueprint: {
      segId: '$..NewSegID'
    }
  })
    .done(function(response) {
      cleanUpResponse(response, { cleanUpTextKeys: true });
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
